import { Link } from "react-router-dom";
import { useCurrentUser } from "./currentUserContext";

export default function MyAccountView() {
  const { selectedUser } = useCurrentUser();

  return (
    <div className="account-shell">
      <div className="account-page-header">
        <div>
          <h1 className="account-page-title">My Account</h1>
          <p className="account-copy">
            Configure how {selectedUser?.label || "this user"} shows up across the app. Start with TradeFinder filters and expand from here.
          </p>
        </div>
      </div>

      <section className="account-folder-grid" aria-label="Account settings categories">
        <Link to="/account/general-settings" className="account-folder-card account-folder-card--compact">
          <span className="account-folder-card__eyebrow">Profile</span>
          <strong className="account-folder-card__title">General Settings</strong>
          <span className="account-folder-card__copy">
            Set the name, city, and country that appear on your Browse Users trader page.
          </span>
        </Link>

        <Link to="/account/tradefinder-settings" className="account-folder-card account-folder-card--compact">
          <span className="account-folder-card__eyebrow">TradeFinder</span>
          <strong className="account-folder-card__title">TradeFinder Settings</strong>
          <span className="account-folder-card__copy">
            Set minimum buy and sale values before this user appears in trade suggestions.
          </span>
        </Link>

        <Link to="/account/my-wants-settings" className="account-folder-card account-folder-card--compact">
          <span className="account-folder-card__eyebrow">My Wants</span>
          <strong className="account-folder-card__title">My Wants Settings</strong>
          <span className="account-folder-card__copy">
            Choose the default language, condition and finish preferences used when you add wanted cards.
          </span>
        </Link>

        <Link to="/account/my-traders-settings" className="account-folder-card account-folder-card--compact">
          <span className="account-folder-card__eyebrow">My Traders</span>
          <strong className="account-folder-card__title">My Traders Settings</strong>
          <span className="account-folder-card__copy">
            Choose the default language, condition and finish preferences used when you add or import trader cards.
          </span>
        </Link>

        <Link to="/account/trade-history" className="account-folder-card account-folder-card--compact">
          <span className="account-folder-card__eyebrow">Trades</span>
          <strong className="account-folder-card__title">Trade History</strong>
          <span className="account-folder-card__copy">
            See your total completed trades and keep track of your trading history.
          </span>
        </Link>

        <Link to="/account/pricing-and-currency" className="account-folder-card account-folder-card--compact">
          <span className="account-folder-card__eyebrow">Pricing</span>
          <strong className="account-folder-card__title">Pricing and Currency</strong>
          <span className="account-folder-card__copy">
            Configure pricing and currency preferences for your account.
          </span>
        </Link>
      </section>
    </div>
  );
}
